import { h, Component, Fragment } from 'preact';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import FullSite from './full-site';
import { TournamentDetails, LeaderboardEntry, DetailsApiResponse, SlotTournamentsService } from '../../../services/slot-tournaments';
import { TournamentDetailsDisplay } from '../desktop-components/TournamentDetailsDisplay';
import { LeaderboardDisplay } from '../desktop-components/LeaderboardDisplay';

import { TournamentLeaderboardContent as AwrabetTournamentLeaderboardContent, TournamentLeaderboardPage as AwrabetTournamentLeaderboardPage } from '../../awrabet/desktop-pages/TournamentLeaderboardPage';

export class TournamentLeaderboardContent extends AwrabetTournamentLeaderboardContent {
    render() {
        const { loading, error, tournament, leaderboard } = this.state;

        if (loading) {
            return <div class="text-center text-white p-10"><Trans>Loading tournament details...</Trans></div>;
        }

        if (error) {
            return <div class="text-center p-10 text-red-600"><Trans>Failed to load tournament data. Please try again later.</Trans></div>;
        }

        return (
            <div class="max-w-6xl mx-auto">
                <TournamentDetailsDisplay tournament={tournament} />
                <LeaderboardDisplay leaderboard={leaderboard} />
            </div>
        );
    }
}

export class TournamentLeaderboardPage extends AwrabetTournamentLeaderboardPage {
    render() {
        const { tournamentId } = this.props;

        return (
            <FullSite>
                 <div class="p-4 md:p-8 bg-harif-800 text-white min-h-screen">
                     <div class="mb-6">
                         {/* Keep the back link as it was */}
                         <a href="/slot-tournaments" class="text-white hover:text-gray-300">
                             &larr; <Trans>Back to Tournaments List</Trans>
                         </a>
                     </div>
                    <TournamentLeaderboardContent tournamentId={tournamentId} />
                </div>
            </FullSite>
        );
    }
}